import axios from "axios";

const token = localStorage.getItem("@supply:token") || "";

axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL_PROD
});


export default api;
